export default __webpack_public_path__ + "static/media/person-profile.f1e8b69b.svg";